module.exports = __webpack_public_path__ + "static/media/ear-muffs.aacb105f.svg";